import clsx from 'clsx';
import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';

/**
 * Icon for a collection.
 */
export function CollectionIcon({
    className,
    size = 18,
}: {
    size?: number;
    className?: string;
}): React.ReactElement {
    return <Icon.Collection size={size} className={clsx('text-muted', className)} />;
}
